const STORAGE_KEY = 'cardstudio_cards';

export const storage = {
  getCards: () => {
    const cards = localStorage.getItem(STORAGE_KEY);
    return cards ? JSON.parse(cards) : [];
  },
  saveCard: (card) => {
    const cards = storage.getCards();
    const existingIndex = cards.findIndex(c => c.card_id === card.card_id);
    const now = new Date().toISOString();
    
    let result;
    if (existingIndex > -1) {
      result = { ...cards[existingIndex], ...card, updated_at: now };
      cards[existingIndex] = result;
    } else {
      result = {
        ...card,
        card_id: card.card_id || `card_${Math.random().toString(36).substr(2, 9)}`,
        created_at: now,
        updated_at: now
      };
      cards.push(result);
    }
    
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cards));
    return result;
  },
  getCard: (cardId) => {
    const cards = storage.getCards();
    return cards.find(c => c.card_id === cardId);
  },
  deleteCard: (cardId) => {
    const cards = storage.getCards();
    const filtered = cards.filter(c => c.card_id !== cardId);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
  }
};
